import { Spacer, SpacerVariant, spacerOptions } from "../components/layout"

import React from "react"
import { options } from "../../types"
import { types } from "react-bricks/frontend"

enum Type {
    "Line" = "line",
    "Dots" = "dots",
}

export interface DividerProps {
    spacerTop?: boolean
    spacerBottom?: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
    text?: string
    type?: Type
}

const Divider: types.Brick<DividerProps> = ({
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
    text,
    type = Type.Line,
}) => {
    return (
        <>
            <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
            {text ? (
                <div className="mb-3.5 flex w-full items-center justify-center gap-x-3 pt-1">
                    <div className="h-px w-full bg-border-tide" />
                    <p className="text-xs uppercase lg:text-base">{text}</p>
                    <div className="h-px w-full bg-border-tide" />
                </div>
            ) : type === Type.Line ? (
                <div className="h-px w-full bg-border-tide sm:h-0.5" />
            ) : (
                <div className="mx-auto flex w-fit gap-1.5 sm:gap-2">
                    <div className="h-1 w-1 rounded-full bg-border-tide sm:h-1.5 sm:w-1.5 print:[print-color-adjust:exact]" />
                    <div className="h-1 w-1 rounded-full bg-border-tide sm:h-1.5 sm:w-1.5 print:[print-color-adjust:exact]" />
                    <div className="h-1 w-1 rounded-full bg-border-tide sm:h-1.5 sm:w-1.5 print:[print-color-adjust:exact]" />
                </div>
            )}
            <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
        </>
    )
}

Divider.schema = {
    name: "Divider",
    label: "Divider",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/Divider.png`,
    sideEditProps: [
        {
            name: "type",
            label: "Type",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: options<typeof Type>(Type),
                display: types.OptionsDisplay.Radio,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): DividerProps => ({
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
        type: Type.Line,
    }),
}

export default Divider
